<template>
	<section v-if="items.length" class="promotions align-center">
		<slot name="blocks-header" />
		<div class="row">
			<div v-for="block in items.slice(0, amount)" :key="block.ID" class="columns column4">
				<div class="promotion">
					<div class="image">
						<picture>
							<source :srcset="block.imageWebp" type="image/webp" />
							<source :srcset="block.image" />
							<img :src="block.image" :alt="block.imageAlt" loading="lazy" />
						</picture>
					</div>
					<div class="content">
						<h4>
							<nuxt-link :to="block.link">
								{{ block.header }}
							</nuxt-link>
						</h4>
						<div v-parse-links v-html="block.content" />
						<nuxt-link :to="block.link" target="_self">
							{{ $t('readMore') }}
						</nuxt-link>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
});
</script>

<style lang="scss" scoped>
.row {
	justify-content: center;
}

.promotions {
	background: var(--cta-color);
	color: #fff;
	padding: 75px 0 0;

	h2,
	:deep(h2) {
		color: #fff;
	}

	.columns {
		display: flex;
	}
}

.promotion {
	background-color: var(--primary-background-color);
	margin: 0 auto 20px;
	box-shadow: 0 0 10px rgb(0 0 0 / 10%);
	position: relative;
	overflow: hidden;
	width: 100%;

	.content {
		position: absolute;
		bottom: 20px;
		left: 20px;
		right: 20px;
		z-index: 3;
		padding: 30px;
		color: #fff;
		backdrop-filter: blur(34px);
		background: rgb(15 55 85 / 70%);

		> a {
			text-decoration: none;
			padding: 0 0 8px;
			border-bottom: 2px solid;
			text-transform: uppercase;
			font-size: calc(var(--body-font-size) - 2px);
		}

		h4 a {
			text-decoration: none;
			color: #fff;
			padding: 0;
			border: none;
			text-transform: none;
		}
	}

	.image {
		display: block;
		overflow: hidden;
		position: relative;

		&::before {
			content: '';
			display: block;
			position: absolute;
			inset: 0;
			background: #000;
		}

		img {
			transition: all 0.3s ease-in-out;
			background: #000;
			opacity: 0.8;
			z-index: 1;
			position: relative;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		&:hover img {
			opacity: 1;
		}
	}
}

@media (max-width: 580px) {
	.promotion {
		.content {
			text-align: center;
		}
	}
}
</style>
